<template>
  <CountryPage country="morocco" />
</template>